import {
  GetPayrollImportSummaryMatchesDocument,
  GetPayrollImportSummaryMatchesQuery,
} from 'generated/resources/graphql'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useQuery } from 'modules/core/hooks/useQuery'

export type PayrollSummaryImportEmployeeMatches =
  GetPayrollImportSummaryMatchesQuery['payroll']['payrollSummaryMatchesConnection']['nodes']
export type PayrollSummaryImportEmployeeMatch = PayrollSummaryImportEmployeeMatches[0]

export const usePayrollSummaryEmployeeMatches = (financePayrollSummaryImportId: number) => {
  const { loading, data, refetch } = useQuery(GetPayrollImportSummaryMatchesDocument, {
    variables: {
      financePayrollSummaryImportId: financePayrollSummaryImportId,
    },
  })

  const matchResults = useUnsafeMemo(() => {
    if (loading || !data) {
      return []
    }

    return data.payroll.payrollSummaryMatchesConnection.nodes
  }, [data, loading])

  return {
    fetching: loading,
    data: matchResults,
    refetch,
  }
}
